"use strict";

var React = require("react"),
    PropTypes = require("prop-types"),
    RadioButton = require("./RadioButton.js"),
    RadioButtonGroup = function RadioButtonGroup(o) {
  return React.createElement("div", {
    style: o.style,
    className: o.className
  }, o.options.map(function (e, t) {
    return React.createElement(RadioButton, {
      key: e.text,
      name: o.name,
      text: e.text,
      value: e.text,
      disabled: o.disabled,
      onChange: o.onChange,
      checked: t === o.checkedIndex,
      isValid: !1 !== e.isValid || e.isValid
    });
  }));
};

RadioButtonGroup.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
  checkedIndex: PropTypes.number
}, RadioButtonGroup.defaultProps = {
  className: "",
  style: null,
  options: [],
  disabled: !1,
  checkedIndex: -1
}, module.exports = RadioButtonGroup;